'use strict';

var $ = require('jquery');
var Highcharts = require('highcharts');
var Draggable = require('draggable');

function convertToNumberFormat(obj){
	var val = obj.toString();
	val = val.replace(/[^\d.-]/g, "");
	val = parseInt( val, 10 ).toString();
	val = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	return val;
}

function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
	}
	return false;
}

function solarCalculator() {
	var defaultKWH = 1000; // Number supplied by Client
	var kwHPerPannel = 37.5; //Number supplied by Client

	var $kwhPerMonth = $('.kWhPerMonthFieldArea input'),
		$slider = $('.panel-slider'),
		$track = $('#panels-track'),
		$grabber = $('#panels-scrubber'),
		$min = $('.panels-min'),
		$max = $('.panels-max'),
		$panelCount = $('.panels-output'),
		$percentOutput = $('.perc-output'),
		$houseFill = $('.house-fill'),
		$panelCountInput = $('.panelCountFieldArea input'),
		$contactButton = $('.solar-contact-button'),
		contactHref = $contactButton.attr('href');

	var count;

	var updateData = {
			panelData: function() {
				var kwhVal = $kwhPerMonth.val(),
					kwh = (kwhVal.replace(/,/g , ""))*1,
					maxPanels = Math.floor(kwh / kwHPerPannel);

				//Update Max Panels
				$max.text(maxPanels);

				//Update Curernt Pannel Count
				var trackWidth = $track.width(),
					grabberPosition = $grabber.position().left,
					grabberPercent = grabberPosition / trackWidth;

				count = Math.ceil(maxPanels * grabberPercent) > maxPanels ? maxPanels : Math.ceil(maxPanels * grabberPercent) < 0 ? 0 : Math.ceil(maxPanels * grabberPercent);

				$panelCount.text(count);

				// if the grabber is at either end of the scale, hide the min or max value
				if ( count == 1 || count == 0 ) {
					$min.addClass('hidden');
				} else {
					$min.removeClass('hidden')
				}
				if ( count >= maxPanels) {
					$max.addClass('hidden');
				} else {
					$max.removeClass('hidden')
				}

				var modifiedPercent = Math.round(((kwHPerPannel*count)/kwh)*100);

				$percentOutput.text(modifiedPercent);
				$houseFill.css('height', modifiedPercent + '%' );

				$panelCountInput.val(count);
				$('.totalPanelCount').text(count);


				$contactButton.attr('href', contactHref + '?panels=' + count + '&kwh=' + kwhVal);


				//update table information based on panel count

				$('#pricing-options-table .savings-row').each(function() {
					var $this = $(this),
						savings = $this.data('savings') * count,
						fixed = Math.abs(savings.toFixed(2)),
						totalSavings = convertToNumberFormat(fixed);

					var prefix = savings < 0 ? '-$' : '$';

					$this.text(prefix + totalSavings)

				});
				updateData.chartData();
			}, // END panelData

			chartData: function() {

				//option 1 settings
	    		var optionOneBaseSavings = [-14.14, -10.52, -8.15, -6.00, -3.13, -0.63, 2.31, 4.46, 6.71, 9.02, 11.41, 13.87, 16.41, 19.02, 21.71, 24.49, 27.34, 30.29, 33.32, 36.45];
	    		var optionOneAdjustedSavings = [];
	    		for (var i=0; i<optionOneBaseSavings.length; i++) {
	    			var adjusted = optionOneBaseSavings[i]*count;
	    			var fixedAdjusted = adjusted.toFixed(2);
	    			optionOneAdjustedSavings.push((fixedAdjusted)*1);
	    		}

	    		//option 2 settings
	    		var optionTwoBaseSavings = [-1294.39, 59.23, 61.60,63.75,66.62,69.12,72.06,74.21,76.46,78.77,81.16,83.62,86.16,88.77,91.46,94.24,97.09,100.04,103.07,106.20];
	    		var optionTwoAdjustedSavings = [];
	    		for (var i=0; i<optionTwoBaseSavings.length; i++) {
	    			var adjusted = optionTwoBaseSavings[i] * count;
	    			var fixedAdjusted = adjusted.toFixed(2);
	    			optionTwoAdjustedSavings.push((fixedAdjusted)*1);
	    		}

	    		//option 3 settings
	    		var optionThreeBaseSavings = [2.22,2.37,2.46,2.55,2.66,2.76,2.88,2.97,3.06,3.15,3.25,3.34,3.45,3.55,3.66,3.77,3.88,4.00,4.12,4.25];
	    		var optionThreeAdjustedSavings = [];
	    		for (var i=0; i<optionThreeBaseSavings.length; i++) {
	    			var adjusted = optionThreeBaseSavings[i]*count,
	    			fixedAdjusted = adjusted.toFixed(2);
	    			optionThreeAdjustedSavings.push((fixedAdjusted)*1);
	    		}

	    		var activeData = [];
	    		var colorsArray = [];

	    		if ($('.solar-option-1 input').is(':checked')) {
	    			activeData.push({ name: "Option 1", data: optionOneAdjustedSavings, });
	    			colorsArray.push('#2cd524');
	    		}
	    		if ($('.solar-option-2 input').is(':checked')) {
	    			activeData.push({ name: "Option 2", data: optionTwoAdjustedSavings });
	    			colorsArray.push('#EE4036');
	    		}
	    		if ($('.solar-option-3 input').is(':checked')) {
	    			activeData.push( { name: "Option 3", data: optionThreeAdjustedSavings });
	    			colorsArray.push('#26A9E0');
	    		}

		        //$('#solarChart').highcharts({
		        Highcharts.chart('solarChart', {
		            chart: { type: 'column' },
		            colors: colorsArray,
		            title: { text: 'Estimated annual savings' },
		            xAxis: {
		                categories: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"],
		                title: {
		            		text: "Years"
		            	}
		            },
		            yAxis: { title: { text: "Dollars" } },
		            tooltip: { valueDecimals: 2, valuePrefix: '$' },
		            credits: { enabled: false },
		            series: activeData

		        });
			} // end chartData function

	}; // END updateData object

	window.setTimeout(function() {
		updateData.panelData();
	},15);

	//Setup and functions for KWH input
	$kwhPerMonth.val(convertToNumberFormat(defaultKWH));

	$kwhPerMonth.on('change', function() {

		var $this = $(this);
		$this.val( convertToNumberFormat( $this.val() ) );
		updateData.panelData();

	});
	$kwhPerMonth.on('keypress', function(ev) {
		var key = ev.which;
		var $this = $(this);
		if ( key >= 48 && key <=57 ) {
			window.setTimeout(function() {
				updateData.panelData();
			}, 15);
		} else {
			ev.preventDefault;
			return false;
		}
	});
	$kwhPerMonth.on('focus', function() {
		if ($kwhPerMonth.val() == 0) {
			$kwhPerMonth.val('');
		}
	});
	$kwhPerMonth.on('focusout', function() {
		if ($kwhPerMonth.val() == '') {
			$kwhPerMonth.val(0);
		}
	});

	// Track and grabber
	var grabber = $grabber.get(0);
	var xMin, xMax;
	function updateMinMax() {
		xMin = 0;
		xMax = grabber.parentNode.clientWidth - grabber.clientWidth;
	}
	updateMinMax();
	var draggable = new Draggable(
			grabber,
			{
				//limit: grabber.parentNode,
				limit: function (
						  x,  // current X coordinate
						  y,  // current Y coordinate
						  x0, // original X coordinate (where drag was started)
						  y0  // original Y coordinate (where drag was started)
						) {

					if (x < xMin) {
						x = xMin;
					} else if (x > xMax) {
						x = xMax;
					}

					// Can't move in x direction
					y = y0;

					return {x: x, y: y};
				},
			    onDragStart: function() {
			    	updateMinMax();
			    },
				onDrag: function() {
					updateData.panelData();
			    }
			}
		);

	$(window).on('resize', function() {
		var xMaxWas = xMax;
		updateMinMax();

		var left = ($grabber.position().left / xMaxWas) * xMax;

		$grabber.css({'left': left+'px'});
		updateData.panelData();
	});

	// pricing option interactions
	$('.solar-pricing-options input').on('change', function() {
		var $this = $(this);
		var id = $this.parent().parent().data('id');
		var checked = $this.is(':checked');

		$('.option-' + id + '-listing').css({
			'display': checked ? 'table-row' : 'none',
			'width' : '100%'
		});

		var checked = $('.solar-pricing-options input:checked').length;

		updateData.chartData();

		if ( checked > 0 ) {
			$('.solar-table-graph').css('display', 'block');
			$('.solar-table-graph-no-options').css('display', 'none');
		} else {
			$('.solar-table-graph').css('display', 'none');
			$('.solar-table-graph-no-options').css('display', 'block');
		}
	});

}

function solarContact() {
	if ($('#solarContact').length > 0) {
		var panelsParam = getQueryVariable('panels');
		var kwhParam = getQueryVariable('kwh');

		if ( panelsParam != 'null' && panelsParam != '') {
			$('.numberOfPanelsFieldArea input').val(panelsParam)
		}
		if ( kwhParam != 'null' && kwhParam != '') {
			$('.kwhPerMonthFieldArea input').val(kwhParam)
		}
	}
}

module.exports = {
	init: function() {

		if ($('#solar-calculator').length > 0){
			solarCalculator();
		}

		if ($('#solarContact').length > 0){
			solarContact();
		}

	}
}
